<script lang="ts">
  import editorInstance from '../../editor';
  import editorStore from '../../editor.store';
  import type {EditorActiveComponent} from '../../types';

  let item: EditorActiveComponent;
  const unmount = editorStore.subscribe(store => {
    item = store.activeComponent;
  });
  const deleteitem = () => {
    editorInstance.history.addHistory('Delete');
    item?.remove();
    editorStore.setActiveComponent(null);
  };
</script>

<div
  on:click={deleteitem}
  class="inline-block cursor-pointer rounded-lg p-2 text-gray-800 transition-all hover:bg-gray-100 hover:text-blue-600"
>
  <span class="fa-regular fa-trash" />
</div>
